import { FunctionComponent, useContext, useEffect } from 'react'
import { pageProperties } from '~/src/utils/analytics/pageEnrichment'

import { LeadContext } from '~/src/models/leads/LeadModel'
import { SalesDemoForm } from '~/src/routes/UserQualification/pages/sales-demo-type'
import { trackEvent } from '~/src/utils/analytics'
import { SalesDemoControl } from './SalesDemoControl'
import { SalesDemoTreatment } from './SalesDemoTreatment'

type Props = {
  onSubmit: (data: SalesDemoForm) => void
  onOverride: () => void
  bookedMeeting?: boolean
  currency?: 'GBP'
}

const initialValues: SalesDemoForm = {
  first_name: '',
  last_name: '',
  company: '',
  interested_in_products: [],
}

export const SalesDemo: FunctionComponent<Props> = ({
  onSubmit,
  onOverride,
  bookedMeeting,
  currency,
}) => {
  const { lead } = useContext(LeadContext)

  useEffect(() => {
    trackEvent('Contact Sales Page Viewed', {
      email: lead?.company_email ?? '',
      ...pageProperties(),
      experiments: lead?.experiments ?? [],
    })
    trackEvent('SS CS DR VE Total Page Viewed', {
      email: lead?.company_email ?? '',
      ...pageProperties(),
    })
  }, [lead?.company_email, lead?.experiments])

  if (bookedMeeting) {
    onOverride()
  }

  const isTreatment = false // Temp disable while qualified chat bot is down

  if (isTreatment) {
    return (
      <SalesDemoTreatment
        initialValues={initialValues}
        currency={currency}
        lead={lead}
        onOverride={onOverride}
        onSubmit={onSubmit}
      />
    )
  }

  return (
    <SalesDemoControl
      initialValues={initialValues}
      currency={currency}
      lead={lead}
      onOverride={onOverride}
      onSubmit={onSubmit}
    />
  )
}
